import {
    apiRequest,
    polaKerjaList,
    polaKerjaActive,
    polaKerjaInactive
} from "../../../../../services/adapters/kepegawaian/polaKerjaService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", polaKerjaList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", polaKerjaInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", polaKerjaActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository